export const stgFirebaseConfig = {
	apiKey: "AIzaSyA_VLMi9_G1DBLd84J1R7Jo1z4Nv7XJxKc",
	authDomain: "call-agents-stg.firebaseapp.com",
	projectId: "call-agents-stg",
	storageBucket: "call-agents-stg.firebasestorage.app",
	messagingSenderId: "783740275191",
	appId: "1:783740275191:web:72f5e70886731a480b06f2",
};
